import EInvoice from './EInvoice'
export default EInvoice
